import { convertFromESTToLocal } from '@/utils/date/temporary';

import type { OCClaimPrintFormResponse } from './api';

export const normalizeOCClaimPrintForm = (data: OCClaimPrintFormResponse) => {
  if (!data) {
    return {};
  }
  return {
    ...data,
    ammendmentDate: convertFromESTToLocal(data?.ammendmentDate),
    dateSubmitted: convertFromESTToLocal(data?.dateSubmitted),
  };
};
